import { css } from 'linaria';
import { Variables } from '../index';

export const theme = css`
    :global() {
        [data-theme='light'] {
            --dialog-background: ${Variables.css.catapultWhite};
            --dialog-close: ${Variables.css.catapultBlack};
        }

        [data-theme='dark'] {
            --dialog-background: ${Variables.css.catapultBlack};
            --dialog-close: ${Variables.css.catapultWhite};
        }
    }
`;

export const root = css`
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const overlay = css`
    background-color: rgba(41, 47, 51, 0.75);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    animation: overlay 0.2s ease-in forwards;

    @keyframes overlay {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
`;

export const container = css`
    background: var(--dialog-background);
    border-radius: 4px;
    box-shadow: ${Variables.css.shadow4};
    padding: ${Variables.css.spacing24};
    max-height: 90%;
    overflow: auto;
    animation: modal 0.2s cubic-bezier(0, 0, 0.2, 1) forwards;

    @keyframes modal {
        0% {
            transform: scale(0.75) translateY(24px);
            opacity: 0;
        }

        100% {
            transform: scale(1) translateY(0px);
            opacity: 1;
        }
    }
`;

export const sizes = {
    small: css`
        width: 40%;
    `,
    medium: css`
        width: 56%;
    `,
    large: css`
        width: 90%;
    `,
};

export const header = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${Variables.css.spacing16};
`;

export const closeButton = css`
    appearance: none;
    border: 0;
    padding: 0;
    background: transparent;
    outline: 0;
    color: var(--dialog-close);

    &:hover {
        opacity: 0.5;
    }
`;

export const footer = css`
    display: flex;
    justify-content: flex-end;
    gap: ${Variables.css.spacing16};
    margin-top: ${Variables.css.spacing32};
`;
